import { Outlet } from "react-router-dom";
import "./dashboardLayout.scss";
import { useSelector } from "react-redux";

import Sidebar from "../navbar/Sidebar";
import { selectCurrentRoles } from "../../features/auth/authSlice";
import { useState } from "react";

const DashboardLayout = () => {
  const roles = useSelector(selectCurrentRoles);
  const { isDashSidebarCollapsed } = useSelector((state) => state.modal);

  // Define the state for the long-running task
  const [isLongRunningTask, setIsLongRunningTask] = useState(false);

  const panelTitle = roles.includes("Admin")
    ? "Admin Panel"
    : roles.includes("Manager")
    ? "Manager Panel"
    : roles.includes("Employee")
    ? "Employee Panel"
    : roles.includes("Applicant")
    ? "Applicant Panel"
    : "Client Panel";

  return (
    <div className={`dashboard${isDashSidebarCollapsed ? " collapsed" : ""}`}>
      <Sidebar panelTitle={panelTitle} />

      <main className="admin-main">
        <section className="admin-content">
          {/* Pass the state to the Outlet's context prop */}
          <Outlet context={{ setIsLongRunningTask }} />
        </section>
      </main>
    </div>
  );
};

export default DashboardLayout;
